import { Injectable } from '@angular/core';
import { CheckoutActions } from '@checkout-v2/data-access';
import { Actions, createEffect, EffectNotification, ofType, OnRunEffects } from '@ngrx/effects';
import { CustomUserActions } from '@user/data-access';
import { exhaustMap, filter, map, Observable, takeUntil } from 'rxjs';

@Injectable()
export class ApplyingBonusEffects implements OnRunEffects {
  resetApplyingBonusWhenChangeLegalEntity$: Observable<CheckoutActions.SetApplyingBonus> = createEffect(() =>
    this.actions$.pipe(
      ofType<CustomUserActions.SetLegalEntityStatus>(CustomUserActions.SET_LEGAL_ENTITY_STATUS),
      filter((action) => Boolean(action.payload)),
      map(() => new CheckoutActions.SetApplyingBonus(0)),
    ),
  );

  constructor(private actions$: Actions) {}

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>): Observable<EffectNotification> {
    return this.actions$.pipe(
      ofType(CheckoutActions.CHECKOUT_INIT),
      exhaustMap(() => resolvedEffects$.pipe(takeUntil(this.actions$.pipe(ofType(CheckoutActions.CHECKOUT_DESTROY))))),
    );
  }
}
